module.exports = __webpack_public_path__ + "img/cabinet.c77cbb79.svg";